module.exports = __webpack_public_path__ + "img/Weapon_52.9fe93d2c.png";